<mat-card class="mt-3">
    <mat-card-content class="context-assignment-card-content">
        <div class="d-flex align-items-center component-header">
            <div class="flex-fill text-center">
                <h6 class="m-0 blue-text">
                    Assignments {{ variation?.variationLabel === 'Base Item' ? null : '(' + assignments?.length + ')' }}
                </h6>
            </div>

            <div
                class="float-end button-position"
                *ngIf="!hideButtons && isSuperAdmin && variation?.variationLabel !== 'Base Item'"
            >
                <button
                    mat-raised-button
                    class="add-modifier-btn"
                    type="button"
                    (click)="onCreateAssignment()"
                    matTooltip="Add an assignment for this variation"
                >
                    <mat-icon>add</mat-icon>
                    Add
                </button>
            </div>
        </div>
        <mat-divider class="card-divider"></mat-divider>
        <div *ngIf="variation?.variationLabel !== 'Base Item'; else noAssignments">
            <div *ngFor="let assignment of assignments; let i = index" class="accordion-container">
                <mat-accordion>
                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title
                                matTooltip="This variation is applied and reused on instances of this item under the following conditions">
                                <mat-icon class="me-1">grain
                                </mat-icon>
                                Assignment {{ i + 1 }}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <mat-divider class="mb-3"></mat-divider>
                        <mat-panel-description class="d-flex flex-column">
                            <button mat-icon-button
                                    matTooltip="Edit Assignment {{ i + 1}}"
                                    style="position: relative; left: 150px;"
                                    *ngIf="!hideButtons && isSuperAdmin"
                                    (click)="onEditAssignment(assignment)">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <p style="padding: 5px">This is applied to
                                the {{ assignment.consumer }} {{ assignment.locationId }}
                                menu for the following instances:</p>
                            <ul>
                                <li *ngFor="let property of assignment?.properties | keyvalue">
                                    <ng-container>
                                        {{
                                            property.key.charAt(0).toUpperCase() +
                                            property.key.slice(1).toLowerCase()
                                        }}
                                        : {{ property.value }}
                                    </ng-container>
                                </li>
                            </ul>
                        </mat-panel-description>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
        <ng-template #noAssignments>
            <div class="d-flex justify-content-center align-items-center">
                <p class="mt-4 text-center">{{ itemTag }} is the default</p>
            </div>
        </ng-template>
    </mat-card-content>
</mat-card>
